// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"shared-form-snackbarerror-wrapper"};